window.__mt.fn.onInvoice = function onInvoice(vm, $httpParamSerializer, $http, $location, $scope, $timeout, getReservations) {
    vm.countries_invoice = window.__mt.setting.codes_phone;
    vm.phone_codes = window.__mt.setting.codes_phone;
    vm.invoice = {};
    vm.user = __mt.setting.user;
    vm.inv = {
        tai: false,
        valid: true,
        country: null
    };
    vm.syncForm = {};
    vm.codes_phone_invoice = window.__mt.setting.codes_phone;
    vm.billings = [];
    vm.billingSelected = {};

    let _idBooking = "";
    let _invoiceResponse = {};
    let itiInvoice = null;
    let itiAccounChange = null;
    let fn = window.__mt.fn;
    let is_agency = isAgency();


    vm.searchReservationInvoice = (id) => {
        vm.loading = true;
        _idBooking = id;
        onReset();
        initSelect();
        $http.get(window.__mt.setting.api_invoice_search, {
            params: {
                id: id
            }
        }).then(onGetReservation, onError);

        if(vm.user){
            getBilling();
        }

    }

    vm.changeInvoiceType = (type) => {
        vm.invoice.data = vm.invoice.data || {};
        vm.invoice.data.type = type;
        vm.invoice.step = vm.invoice.step = '';
        vm.invoice.step = 'invoice_data';
    }

    vm.onSubmitInvoice = (form) => {
        vm.invoice.submit = true;
        var countryData = itiInvoice.getSelectedCountryData();
        vm.invoice.data.phone_code = `+${countryData.dialCode}`;

        if (form.$valid) {
            vm.loading = true;
            vm.invoice.data.phone_number = vm.invoice.data.phone_number.trim();
            vm.invoice.booking = _invoiceResponse;
            vm.invoice.is_agency = isAgency();

            $http.post(window.__mt.setting.api_invoice_store, vm.invoice).then(onPostInvoice, onError)
        }
    }

    vm.onChangeTai = () => {
        if (vm.invoice.data.country != 'ES') {
            vm.invoice.data.tai = false;
        }
    }


    vm.download = () => {
        var param = {
            id: _invoiceResponse.bookedDetails[0].bookingReference,
            lang: window.__mt.ln.lang
        }
        downloadFile(param);
    }

    vm.onChangePhone = () => {
        vm.invoice.data.phone_number = vm.fake_phone_number;
    };

    vm.openModalInvoice = (id) => {
        $(`#${id}`).modal("show");
        $("#c-modal-invoice").modal("hide");

        if (id == 'c-modal-change-account') {
            initializeChangeAccount();
        }
    }

    vm.onSubmitChangeAccount = (form) => {
        if (form.$valid && vm.inv.valid) {
            var countryData = itiAccounChange.getSelectedCountryData();
            vm.inv.phone_number = itiAccounChange.getNumber();
            vm.inv.dial_code = `+${countryData.dialCode}`;
            vm.inv.phone_number = vm.inv.phone_number.replace(vm.inv.dial_code, "");
            
            $http.post(window.__mt.setting.route_change_account, vm.inv).then(onSuccessChangeAccount, onError)
        }

    }

    vm.syncModal = () =>  {
        vm.syncForm = {
            error : false
        };
        $(`#c-modal-sync-reservation`).modal("show");
    }

    vm.onSubmitSyncReservation = (form) => {
        console.log(form, vm.syncForm)
        if (form.$valid) {
            $http.post( window.__mt.setting.route_sync_reservation , vm.syncForm).then(onSuccessSyncReservation, onError)
        }

    }

    vm.filterTypeBilling = (bill) =>  {
        return bill.type == vm.invoice.data.type;
    }

    vm.onSelectedBilling = (bill) => {
        vm.billingSelected = bill;
    }

    vm.onCreateByBilling = ()=> {
        vm.invoice.submit = true;

        if (vm.billingSelected && vm.billingSelected.id) {
            vm.loading = true;

            vm.invoice.billing = vm.billingSelected;
            vm.invoice.booking = _invoiceResponse;
            vm.invoice.is_agency = isAgency();
            vm.invoice.is_billing = true;

            $http.post(window.__mt.setting.api_invoice_store, vm.invoice).then(onPostInvoice, onError)
        }
    }

    function initializeChangeAccount() {
        initSelectChangeAccount();
    }

    function initSelect() {
        var initialCountry = window.__mt.setting.user && window.__mt.setting.user.country && window.__mt.setting.user.country.length;
        if (!initialCountry && vm.invoice && vm.invoice.data && vm.invoice.data.country) {
            initialCountry = vm.invoice.data.country;
        }

        var input = document.querySelector("#phone_number_fake");
        if (itiInvoice) {
            input.value = "";
            itiInvoice.destroy();
        }



        itiInvoice = window.intlTelInput(input, {
            utilsScript: "https://d1cj8q6w07zyiq.cloudfront.net/mytransfersweb/prod/js/libs/utils.js",
            separateDialCode: true,
            localizedCountries: window.__mt.setting.format_codes,
            preferredCountries: window.__mt.setting.preferred_countries
        });

        if (vm.invoice && vm.invoice.data && vm.invoice.data.phone_code && vm.invoice.data.phone_number) {
            itiInvoice.setNumber(vm.invoice.data.phone_code + vm.invoice.data.phone_number);
        }

        input.addEventListener('blur', () => {
            if (input.value.trim()) {
                var vali = true;
                if (!itiInvoice.isValidNumber()) {
                    vali = false
                }
                $scope.$apply(() => {
                    vm.validnumber = vali;
                });
            }
        });

        input.addEventListener("countrychange", () => {
            var country = itiInvoice.getSelectedCountryData();
            if (country && country.dialCode) {

                $scope.$apply(() => {
                    if (country && country.dialCode) {
                        vm.invoice.data.phone_code = '+' + country.dialCode;
                    } else {
                        vm.invoice.data.phone_code = '';
                    }
                });
            }
        });
    }

    function initSelectChangeAccount() {

        var input = document.querySelector("#phone_invoice");
        if (itiAccounChange) {
            input.value = "";
            itiAccounChange.destroy();
        }

        itiAccounChange = window.intlTelInput(input, {
            utilsScript: "https://d1cj8q6w07zyiq.cloudfront.net/mytransfersweb/prod/js/libs/utils.js",
            separateDialCode: true,
            localizedCountries: window.__mt.setting.format_codes,
            preferredCountries: window.__mt.setting.preferred_countries
        });


        input.addEventListener('blur', () => {
            if (input.value.trim()) {
                var vali = true;
                if (!itiAccounChange.isValidNumber()) {
                    vali = false
                }
                $scope.$apply(() => {
                    vm.inv.valid = vali;
                });
            }
        });

        input.addEventListener("countrychange", () => {
            var country = itiAccounChange.getSelectedCountryData();
            if (country && country.dialCode) {
                $scope.$apply(() => {
                    if (country && country.dialCode) {
                        vm.inv.dial_code = '+' + country.dialCode;
                    } else {
                        vm.inv.dial_code = '';
                    }
                    vm.inv.valid = itiAccounChange.isValidNumber();
                });
            }
        });
    }

    function onReset() {
        vm.invoice.email = '';
        vm.invoice.bookingNumber = '';
        vm.invoice.lang = window.__mt.ln.lang;
        vm.invoice.exchange_convertion = window.__mt.setting.exchange.convertion;
        vm.invoice.ln = {};
        vm.invoice.ln.currency_code = window.__mt.ln.currency_code;
        vm.invoice.step = 'invoice_type';
        vm.invoice.submit = false;
        vm.invoice.booking = {};
        if (window.__mt.user_id) {
            vm.invoice.user_id = window.__mt.user_id;
        }

        var user_data = window.__mt.my_billing_information || {};
        vm.invoice.id = user_data.id || null;
        vm.invoice.data = {
            name: user_data.name_invoice || '',
            address: user_data.address || '',
            postal_code: user_data.postal_code || '',
            identify_code: user_data.number || '',
            country: user_data.country || '',
            city: user_data.city || '',
            tai: user_data.client_tai || false,
            phone_code: user_data.dial_code || '',
            phone_number: user_data.phone || '',
            email: user_data.email || '',
        };
        vm.billingSelected = {};
    }

    function init() {
        var search = window.__mt.fn.searchToObject();
        if (search.email && search.bookingNumber && vm._s) {
            vm._s.booking_number = search.bookingNumber;
            vm._s.email = search.email;
            getReservations()
        }
    };

    function onGetReservation(data) {
        var response = data.data;
        vm.loading = false;
        if (response.code == 200) {
            _invoiceResponse = response.booking;
            let invoiceCreated = fn.findObject(_invoiceResponse.invoiceList, 'type', 'F')

            if (!invoiceCreated && is_agency) {
                beforeAutoGenerateInvoice()
                return;
            }

            if (invoiceCreated) {
                vm.invoice.step = 'invoice_download';
            }

            $("#c-modal-invoice").modal("show");


        } else {
            onError(data)
        }

    }

    function beforeAutoGenerateInvoice(){
        var user_data = window.__mt.setting.userData.agency || {};
        var params = {
            country: user_data.country || "",
            code: user_data.reg_number || ""
        };

        $http.get(window.__mt.setting.api_vies, { params: params}).then(autoGenerateInvoice, onError);
        
    }

    function onPostInvoice(data) {
        var response = data.data;
        vm.loading = false;
        if (response.code == 200) {
            $("#c-modal-invoice").modal("show");
            vm.invoice.step = 'invoice_download';
            var param = {
                id: _invoiceResponse.bookedDetails[0].bookingReference,
                lang: window.__mt.ln.lang
            }
            downloadFile(param);
        } else {
            onError(data);
        }

    }

    function onError(data) {
        console.log(data);
        vm.loading = false;
        alert('Ha ocurrido un error')
    }

    function downloadFile(params) {
        var query = $httpParamSerializer(params);
        var url = window.__mt.setting.api_invoice_download + "?" + query;
        //var fileName = url.split("/").pop();
        var a = document.createElement("a");
        a.href = url;
        a.download = params.id + ".pdf";
        a.setAttribute("target", "_blank")
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();

    }

    function isAgency() {
        return !!(window.__mt.setting.user && window.__mt.setting.user.type && window.__mt.setting.user.type == 'agency');
    }

    vm.redirectToProfile = () => {
        window.location.href = '/' + window.__mt.ln.lang + '/profile/account';
    }

    function autoGenerateInvoice(data) {
        var response = data.data;
        if (response && response.valid && hasValidDataB2B()) {
            var billing = window.__mt.setting.userData.billing_information;
            if (!billing) {
                vm.loading = false;
                vm.invoice.step = 'no_billing_data';
                $("#c-modal-invoice").modal("show");
                return;
            }
            vm.loading = true;
            var user_data = window.__mt.setting.userData.agency;
            vm.invoice.data = {
                name: user_data.fiscal_name || '',
                address: user_data.address || '',
                postal_code: user_data.postal_code || '',
                identify_code: user_data.reg_number || '',
                country: user_data.country || '',
                city: user_data.city || '',
                tai: user_data.client_tai || false,
                phone_code: user_data.dial_code || '',
                phone_number: user_data.phone || '',
                email: user_data.email || '',
                type: 'entity',
            };
            vm.invoice.user_id = user_data.user_id;
            vm.invoice.id = billing.id;
            vm.invoice.booking = _invoiceResponse;
            vm.invoice.is_agency = isAgency();

            $http.post(window.__mt.setting.api_invoice_store, vm.invoice).then(onPostInvoice, onError);
        } else {
            vm.invoice.step = 'fill_data';
            $("#c-modal-invoice").modal("show");
        }
    }

    function hasValidDataB2B() {
        var isValid = false;
        var userData = window.__mt.setting.userData.agency;

        if (
            userData &&
            userData.address &&
            //userData.city &&
            userData.country &&
            //userData.dial_code &&
            userData.phone &&
            userData.postal_code &&
            userData.fiscal_name &&
            userData.email &&
            userData.reg_number &&
            userData.commercial_name &&
            isValidClientTai()
        ) {
            isValid = true;
        }

        return isValid;
    }

    function isValidClientTai(){
        var userData = window.__mt.setting.userData.agency;
        var isValid = true;
        if(userData.country == 'ES'){
            if(!userData.province_id || !userData.municipality_id){
                isValid = false;
            }
        }

        return isValid;
    }

    function onSuccessChangeAccount(data) {
        let response = data.data;
        if (response.code == 200) {
            location.reload()
        } else {
            onError(response);
        }

    }

    function onSuccessSyncReservation(data) {
        let response = data.data;
        if (response.code == 200) {
            vm.syncForm.status = response.status;
            if(vm.syncForm.status == 'OK'){
                location.reload()
            }

        } else {
            onError(response);
        }
    }


    function getBilling() {
        var params = {
            params: {
                page: vm.currentPage,
                limit: vm.limit
            }
        }

        $http.get(window.__mt.setting.web_billing, params).then(successBilling, onError);
    }

    function successBilling(data) {
        response = data.data;
        vm.billings = response || [];
    }


    init();
}
